import React, { useEffect } from "react";
import { Typography, Box, Slider } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import ConfigSwitch from "./common/ConfigSwitch";
import { IconBrightness, IconVolume } from "@/components/Icon";
import styles from "./index.module.less";
import { useUpdateEffect } from "ahooks";

const SystemControl = ({ values, onChange, readOnly }) => {
  const { t } = useTranslation();

  useUpdateEffect(() => {
    if (values.brightness.open) {
      onChange({
        target: {
          name: `${systemControlName}.brightness.value`,
          value: 30
        }
      });
    } else {
      onChange({
        target: {
          name: `${systemControlName}.brightness.value`,
          value: 0
        }
      });
    }
  }, [values.brightness.open]);
  useUpdateEffect(() => {
    onChange({
      target: {
        name: `${systemControlName}.brightness.open`,
        value: !!values.brightness.value
      }
    });
  }, [values.brightness.value]);

  useUpdateEffect(() => {
    if (values.volume.open) {
      onChange({
        target: {
          name: `${systemControlName}.volume.value`,
          value: 30
        }
      });
    } else {
      onChange({
        target: {
          name: `${systemControlName}.volume.value`,
          value: 0
        }
      });
    }
  }, [values.volume.open]);
  useUpdateEffect(() => {
    onChange({
      target: {
        name: `${systemControlName}.volume.open`,
        value: !!values.volume.value
      }
    });
  }, [values.volume.value]);

  return (
    <Box flex={1}>
      <Typography variant="h5" style={{ marginBottom: 32 }}>
        {t({ defaultMessage: "功能控制" })}
      </Typography>
      <ConfigSwitch
        title={t({ defaultMessage: "是否启用" })}
        name={`${systemControlName}.open`}
        onChange={onChange}
        marginBottom={3}
        value={values.open}
      />
      {values.open && (
        <>
          <div className={styles.systemControlCard}>
            <ConfigSwitch
              prefix={<IconBrightness size={20} style={{ marginRight: 10 }} />}
              title={t({ defaultMessage: "亮度" })}
              name={`${systemControlName}.brightness.open`}
              onChange={onChange}
              marginBottom={1}
              value={values.brightness.open}
            />
            <Box display="flex">
              <Slider
                value={values.brightness.value}
                onChange={(e, value) =>
                  onChange({
                    target: {
                      name: `${systemControlName}.brightness.value`,
                      value
                    }
                  })
                }
              />
              <Typography style={{ marginLeft: 24 }}>
                {values.brightness.value}
              </Typography>
            </Box>
          </div>
          <div className={styles.systemControlCard}>
            <ConfigSwitch
              prefix={<IconVolume size={20} style={{ marginRight: 10 }} />}
              title={t({ defaultMessage: "音量" })}
              name={`${systemControlName}.volume.open`}
              onChange={onChange}
              marginBottom={1}
              value={values.volume.open}
            />
            <Box display="flex">
              <Slider
                value={values.volume.value}
                onChange={(e, value) =>
                  onChange({
                    target: {
                      name: `${systemControlName}.volume.value`,
                      value
                    }
                  })
                }
              />
              <Typography style={{ marginLeft: 24 }}>
                {values.volume.value}
              </Typography>
            </Box>
          </div>
        </>
      )}
    </Box>
  );
};

export const initValues = {
  open: false,
  brightness: {
    open: true,
    value: 30
  },
  volume: {
    open: true,
    value: 30
  }
};
export const systemControlName = "functionControl";
export default SystemControl;
